import type { InspoPreview } from "../../../../lib/api";

export type InspoSlot =
  | { state: "idle" }
  | { state: "loading" }
  | { state: "ok"; preview: InspoPreview }
  | { state: "error"; message: string };

export function InspoPreviewCard({ slot }: { slot: InspoSlot }) {
  if (slot.state === "idle") return null;
  if (slot.state === "loading") {
    return (
      <div className="inspo-card" style={{ opacity: 0.7 }}>
        <div className="inspo-skeleton" style={{ width: 56, height: 56 }} />
        <div className="stack" style={{ gap: 6, flex: 1 }}>
          <div className="inspo-skeleton" style={{ height: 12, width: "60%" }} />
          <div className="inspo-skeleton" style={{ height: 10, width: "85%" }} />
        </div>
      </div>
    );
  }
  if (slot.state === "error") {
    return (
      <div className="inspo-card error">
        <div style={{ fontSize: 12, color: "#b91c1c" }}>⚠ {slot.message}</div>
      </div>
    );
  }
  const p = slot.preview;
  return (
    <div className="inspo-card">
      {p.image ? (
        <img src={p.image} alt="" className="inspo-thumb" loading="lazy" onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = "none"; }} />
      ) : (
        <div className="inspo-thumb" style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "#f3f4f6" }}>
          <img src={p.favicon} alt="" style={{ width: 32, height: 32 }} />
        </div>
      )}
      <div className="stack" style={{ gap: 2, flex: 1, minWidth: 0 }}>
        <div className="row" style={{ gap: 6, alignItems: "center" }}>
          <img src={p.favicon} alt="" style={{ width: 14, height: 14, flexShrink: 0 }} />
          <span className="muted" style={{ fontSize: 12, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {p.hostname}
          </span>
        </div>
        <div style={{ fontWeight: 600, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {p.title}
        </div>
        {p.description && (
          <div className="muted" style={{
            fontSize: 12,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: 1.4,
          }}>{p.description}</div>
        )}
      </div>
    </div>
  );
}

